import { Reducer } from "redux";

import { CUSTOMER_MODE } from "@montana/constants/customer-mode";

import { ISettingsContainerState } from "./settings";
import { ISettingsAction, SettingsAction } from "./settings.actions";

const initialState: ISettingsContainerState = {
    customerMode: CUSTOMER_MODE.PRIVATE,
    infoToolboxs: []
};

export const settingsReducer: Reducer<ISettingsContainerState, ISettingsAction> = (state = initialState, action) => {
    switch (action.type) {
        case SettingsAction.INIT_SETTINGS: {
            return {
                ...state,
                ...action.settings
            };
        }

        case SettingsAction.SET_CUSTOMER_MODE: {
            return {
                ...state,
                customerMode: action.customerMode,
            };
        }

        case SettingsAction.SET_INFO_TOOLBOX:
            return {
                ...state,
                infoToolboxs: [...state.infoToolboxs, action.infoToolbox]
            }

        case SettingsAction.SET_LANGUAGE_AND_MARKET: {
            const newState: Omit<ISettingsContainerState, 'customerMode' | 'infoToolboxs'> = {};
            if (action.market) {
                newState.market = action.market;
            }
            if (action.language) {
                newState.language = action.language;
            }
            return {
                ...state,
                ...newState
            }
        }

        case SettingsAction.SET_LANGUAGE: {
            return {
                ...state,
                language: action.language
            }
        }

        default: {
            return {
                ...state
            };
        }
    }
};
